module.exports = __webpack_public_path__ + "static/media/iptu.17def94a.svg";